import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { zustandPlugin } from '@/modules/shared/openreplay'

const getDefaultViewedYear = () => {
  const d = new Date()
  d.setMonth(d.getMonth() - 1)
  return d.getFullYear()
}

export type DriversGroupTimesheetState = {
  viewedYear: number
}

type Actions = {
  setViewedYear: (year: number) => void
}

export const useDriversGroupTimesheetStore = create<
  DriversGroupTimesheetState & Actions
>()(
  devtools(
    zustandPlugin((set) => ({
      viewedYear: getDefaultViewedYear(),
      setViewedYear: (year) =>
        set({ viewedYear: year }, false, 'setViewedYear'),
    }), 'drivers-group-timesheet'),
    { name: 'EasyTacho', store: 'drivers-group-timesheet' },
  ),
)
